/* TDHQ contact page — Contact brief sections 18, 20, 22-25, 44.

   - Conditional field groups follow the enquiry type (hidden groups are also
     disabled so empty irrelevant fields never reach the notification).
   - ?enquiry=<code> in the URL preselects a type.
   - A hidden field mirrors the customer-facing label of the chosen type.
   - Submit: disabled + "Sending..." while the request is in flight, so a
     double click cannot send twice. Honeypot filled in = nothing is sent.
   - Focus moves to the success / error summary after the page reloads.
   - Analytics: non-personal parameters only (enquiry type, method, label,
     customer state, device) — never name, email, phone, order number, message.
*/
(function () {
  'use strict';

  /* RE-RUNNABLE. This used to be a one-shot IIFE behind a global flag, with the
     form captured at parse time. That is correct on a real page load and wrong
     in the theme editor: editing the contact section re-renders it, the browser
     does NOT execute a <script src> that arrives inside injected HTML, and the
     merchant is left with a form that has no conditional fields, no
     double-submit guard and no honeypot check - silently, with no error.

     The guard is per-FORM now rather than per-page, so a re-render initialises
     the new form exactly once and can never double-bind the old one. */
  var pageshowBound = false;

  function init() {
  var form = document.querySelector('[data-tdhq-contact]');
  if (form && form.dataset.tdhqContactReady) { return; }
  if (form) { form.dataset.tdhqContactReady = '1'; }
  var customerState = form ? (form.getAttribute('data-tdhq-customer-state') || 'guest') : 'guest';

  function track(name, params) {
    var detail = params || {};
    detail.customer_state = customerState;
    detail.device_type = window.innerWidth < 768 ? 'mobile'
                       : window.innerWidth < 1100 ? 'tablet' : 'desktop';
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, detail));
    }
    document.dispatchEvent(new CustomEvent('tdhq:' + name, { detail: detail }));
  }

  /* Click tracking for [data-tdhq-event] lives in tdhq-header.js (site-wide). */

  if (!form) return;

  var type = form.querySelector('[data-tdhq-enquiry-type]');
  var groups = Array.prototype.slice.call(form.querySelectorAll('[data-tdhq-when]'));
  var mirror = form.querySelector('[data-tdhq-enquiry-label]');
  var submit = form.querySelector('[data-tdhq-submit]');
  var hp = form.querySelector('[data-tdhq-hp]');
  var started = false;

  function currentLabel() {
    if (!type || !type.value) return '';
    var opt = type.options[type.selectedIndex];
    return opt ? opt.text : '';
  }

  function sync() {
    var v = type ? type.value : '';
    groups.forEach(function (g) {
      var wants = g.getAttribute('data-tdhq-when').split(',');
      var show = !!v && wants.indexOf(v) > -1;
      g.hidden = !show;
      Array.prototype.forEach.call(g.querySelectorAll('input, select, textarea'), function (f) {
        f.disabled = !show;
      });
    });
    if (mirror) mirror.value = currentLabel();
  }

  if (type) {
    /* Preselect from ?enquiry=code (specialist cards, other pages).
       The change event matters: the styled dropdown (dtc-select.js) was
       already built from the empty value and only repaints on change, so
       "Ask about your order" opened the form reading "Please choose..." over
       a select that was in fact set. It fires before the tracking listener
       below is attached, so it records no enquiry-type event. */
    try {
      var want = new URLSearchParams(window.location.search).get('enquiry');
      if (want && !type.value) {
        for (var i = 0; i < type.options.length; i++) {
          if (type.options[i].value === want) {
            type.value = want;
            type.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }
    } catch (err) { /* URLSearchParams unavailable: nothing to preselect */ }

    sync();
    type.addEventListener('change', function () {
      sync();
      if (type.value) track('contact_enquiry_type_select', { enquiry_type: type.value });
    });
  }

  /* First interaction = the form was started (fires once). */
  form.addEventListener('focusin', function (e) {
    if (started) return;
    if (!e.target.matches('input, select, textarea')) return;
    started = true;
    track('contact_form_start', {});
  });

  /* Submit: the browser has already run constraint validation by the time
     this fires, so a submit event means every required field is filled. */
  form.addEventListener('submit', function (e) {
    /* HONEYPOT. Refusing in silence is indistinguishable from a broken site:
       the shopper clicks Send, nothing happens, and they have no field to
       correct because the one that failed is invisible. If a person really did
       trip it - autofill is the usual way - they get a message and a route to
       a human instead of a dead button. */
    if (hp && hp.value) {
      e.preventDefault();
      var box = form.querySelector('[data-tdhq-form-err], .tdhq-form__err');
      if (!box) {
        box = document.createElement('div');
        box.className = 'tdhq-form__err';
        box.setAttribute('role', 'alert');
        box.setAttribute('tabindex', '-1');
        box.setAttribute('data-tdhq-form-err', '');
        form.insertBefore(box, form.firstChild);
      }
      box.innerHTML = '<p>We could not send your enquiry at the moment. Please try again or contact us by ' +
        (form.getAttribute('data-tdhq-alt-contact') || 'WhatsApp or telephone') + '.';
      box.hidden = false;
      box.focus({ preventScroll: true });
      box.scrollIntoView({ behavior: (window.tdhqMotion ? window.tdhqMotion.behavior() : 'smooth'), block: 'center' });
      return;
    }
    if (form.dataset.sending) { e.preventDefault(); return; }
    form.dataset.sending = '1';
    if (submit) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.dataset.idleLabel = submit.textContent;
      submit.textContent = submit.getAttribute('data-sending-label') || 'Sending...';
    }
    track('contact_form_submit', { enquiry_type: type ? type.value : '' });
  });

  /* Back/forward cache can restore the page mid-"Sending..." — reset it. */
  if (!pageshowBound) {
  pageshowBound = true;
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    delete form.dataset.sending;
    if (submit) {
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
      if (submit.dataset.idleLabel) submit.textContent = submit.dataset.idleLabel;
    }
  });
  }

  /* After the post-submit reload: announce and focus the outcome. */
  var ok = form.querySelector('[data-tdhq-form-ok]');
  var err = form.querySelector('[data-tdhq-form-err]');
  if (ok) {
    track('contact_form_success', {});
    ok.focus();
  } else if (err) {
    track('contact_form_error', { enquiry_type: type ? type.value : '' });
    err.focus();
  }
  }

  init();

  /* Shopify fires this when a section is re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t || !t.querySelector) { return; }
    if (t.querySelector('[data-tdhq-contact]') || (t.matches && t.matches('[data-tdhq-contact]'))) {
      init();
    }
  });
})();
